import axios from "axios";

import { msalInstance } from "../services/entraId";

import { api } from "./config";

// Setzt das `Authorization`-Header zentral
export const setAuthHeader = async () => {
  const token = await getBackendToken();
  if (token) {
    api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  }
};

const setTokeninLocalStorage = (token) => {
  localStorage.setItem("token", token);
};

const setInLocalStorage = (key, value) => {
  localStorage.setItem(key, value);
};

const removeInLocalStorage = (key) => {
  localStorage.removeItem(key);
};

const getInLocalStorage = (key) => {
  return localStorage.getItem(key);
};

export async function getBackendToken() {
  // Nimm den User aus der MSAL-Session (falls mehrere Accounts, nimm [0])
  const account = msalInstance.getAllAccounts()[0];
  if (!account) {
    throw new Error("No user logged in");
  }

  const tokenResponse = await msalInstance.acquireTokenSilent({
    account, // das Benutzerkonto
    scopes: ["api://87a288bd-081d-4ebe-95fb-853e7ec9235f/access_as_user"],
  });

  return tokenResponse.accessToken;
}

const setAuthorizationHeader = (token) => {
  if (token) {
    axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    return true;
  }

  return false;
};

const removeAuthorizationHeader = () => {
  localStorage.removeItem("token");
  axios.defaults.headers.common["Authorization"] = undefined;
};

const decodeJWTToken = (token) => {
  const base64Url = token.split(".")[1];
  const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  const jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split("")
      .map((c) => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
      .join("")
  );

  return JSON.parse(jsonPayload);
};

const calculateImage = (username) => {
  try {
    let sPath = "";
    switch (true) {
      case username.startsWith("AUTHPILOT"):
        sPath = "logo_AuthPilot_consiness.png";
        break;
      case username === "fhaydecker":
        sPath = "fhaydecker.png";
        break;
      case username === "lbaese":
        sPath = "lbaese.jpeg";
        break;
      default:
        sPath = "consiness-Raute.png";
    }
    return `../images/${sPath}`;
  } catch (error) {
    return "../images/consiness-Raute.png"; // Fallback-Bild
  }
};

export {
  calculateImage,
  setAuthorizationHeader,
  removeAuthorizationHeader,
  setTokeninLocalStorage,
  setInLocalStorage,
  removeInLocalStorage,
  decodeJWTToken,
  getInLocalStorage,
};
